module.exports = __webpack_public_path__ + "static/media/cc_mastercard.807fb5b1.svg";